import React from "react";
import { Col, Row } from "antd";

import FormInput from "components/FormInput/FormInput";
import SectionCard from "components/SectionCard/SectionCard";
import SectionContainer from "components/SectionContainer/SectionContainer";
import Locale from "react-intl-universal";

const OtherInfo = () => {
  return (
    <>
      <SectionContainer>
        <SectionCard title={Locale.get("ownedPolicies.otherInfoTab.aplPolicy")}>
          <Row gutter={16}>
            <Col span={24} lg={12}>
              <FormInput
                label={Locale.get("ownedPolicies.otherInfoTab.aplAmount")}
                name={["apl", "amount"]}
                placeholder="0.00"
                type="financial"
              />
            </Col>
            <Col span={24} lg={12}>
              <FormInput
                label={Locale.get("ownedPolicies.otherInfoTab.policyAmount")}
                name={["policyLoan", "amount"]}
                placeholder="0.00"
                type="financial"
              />
            </Col>
          </Row>
        </SectionCard>
      </SectionContainer>
      <SectionContainer>
        <SectionCard
          title={Locale.get("ownedPolicies.otherInfoTab.surrenderFundValue")}
        >
          <Row gutter={16}>
            <Col span={24} lg={14}>
              <FormInput
                label={Locale.get("ownedPolicies.otherInfoTab.gSurrenderValue")}
                name={["surrenderValue", "guaranteedValue", "amount"]}
                placeholder="0.00"
                type="financial"
              />
            </Col>
            <Col span={24} lg={10}>
              <FormInput
                label={Locale.get("ownedPolicies.otherInfoTab.fundValue")}
                name={["surrenderValue", "dividend", "amount"]}
                placeholder="0.00"
                type="financial"
              />
            </Col>
            <Col span={24} lg={12}>
              <FormInput
                label={Locale.get("ownedPolicies.otherInfoTab.rCashPayout")}
                name={["surrenderValue", "regularCashPayout", "amount"]}
                placeholder="0.00"
                type="financial"
              />
            </Col>
            <Col span={24} lg={12}>
              <FormInput
                label={Locale.get("ownedPolicies.otherInfoTab.terminalDiv")}
                name={["surrenderValue", "terminalDividend", "amount"]}
                placeholder="0.00"
                type="financial"
              />
            </Col>
          </Row>
        </SectionCard>
      </SectionContainer>
    </>
  );
};

export default OtherInfo;
